import { useContext } from "react";
import { Link } from "react-router-dom";
import {authContex, AuthContext} from "../../context/AuthProvider"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faTimes,
  faSignOut,
} from "@fortawesome/free-solid-svg-icons";

const Navbar = ({toggleMenu, navLinks, title, menuStatus }) => {
const {logout}=useContext(AuthContext)
 const handleLogout=()=>{
    logout()
  }
  
  const allNavLinks=[
   ...navLinks,
    { name: "Logout", url: "#", icon: faSignOut, color: "text-red-500", func:handleLogout },
  ]


  const links = allNavLinks.map((link) => {
    return (
      <li key={link.name} onClick={link.func || null}>
        <Link to={link.url} className="hover:text-gray-400">
          <FontAwesomeIcon icon={link.icon} className={link.color} size="lg" />
        </Link>
      </li>
    );
  });

  return (
    <>
      <nav className="flex justify-between items-center pl-6 pr-2  py-2 md:py-4 bg-gray-900 text-white shadow-md fixed left-0 top-0 w-full z-40">
        <div className="flex gap-10 -ml-3">
          <button
            className="block md:hidden w-[10px]"
            onClick={toggleMenu}
          >
            {!menuStatus ? (
              <FontAwesomeIcon icon={faBars} size="2x" />
            ) : (
              <FontAwesomeIcon
                icon={faTimes}
                className="hover:text-red-500"
                size="2x"
              />
            )}
          </button>
          <h1 className="text-xl text-center md:text-2xl font-bold">{ title ||"Admin Panel"}</h1>
        </div>
        <ul className="flex space-x-6">{links}</ul>
      </nav>
    </>
  );
};

export default Navbar;
